import { type ItemTabProps, TabBar, useRouter } from '@capsicum/common-web';
import {
	CURRENCY_LABELS,
	CurrencyType,
	type TransactionHistorySegments,
	TransactionHistoryTabNames
} from '@capsicum/features/wallet/shared';
import { useCallback, useMemo } from 'react';

import TransactionCardsByDay from './components/TransactionCardsByDay';

const tabViews = [
	{
		component: () => <TransactionCardsByDay type="chz" />,
		id: TransactionHistoryTabNames.Chiliz,
		text: CURRENCY_LABELS[CurrencyType.CHILIZ]
	},
	{
		component: () => <TransactionCardsByDay type="fan_token" />,
		id: TransactionHistoryTabNames.FanTokens,
		text: CURRENCY_LABELS[CurrencyType.FANTOKENS]
	}
	// You can add more tabs here as needed
] satisfies Array<ItemTabProps>;

export const Transactions = () => {
	const { replace, searchParams } = useRouter();

	const activeTabParam = searchParams?.get('tab');
	const isValidTab =
		activeTabParam &&
		Object.values(TransactionHistoryTabNames).includes(activeTabParam as TransactionHistorySegments);

	const activeTab: TransactionHistorySegments = isValidTab
		? (activeTabParam as TransactionHistorySegments)
		: TransactionHistoryTabNames.Chiliz;

	const handleChangeSelected = useCallback(
		(screenId?: string) => {
			screenId && replace(`/wallet/transactions?tab=${screenId}`);
		},
		[replace]
	);

	return (
		<>
			{useMemo(
				() => (
					<TabBar
						flexVertically
						items={tabViews}
						selected={activeTab}
						testID="transactions-navigation-tabs"
						variant="fixed"
						onChangeSelected={handleChangeSelected}
					/>
				),
				[activeTab, handleChangeSelected]
			)}
		</>
	);
};
